export const madeiraPicoArieiroAtlanticProgram = {
  programKey: 'madera-z-pico-do-arieiro-nad-atlantyk',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Madera - Z Pico do Arieiro nad Atlantyk',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Madera:',
  stickySubtitle: 'Z Pico do Arieiro nad Atlantyk',

  pageUrl:
    'https://coolturystki.pl/wycieczki/madera-z-pico-do-arieiro-nad-atlantyk',

  /*
   * Dane wykorzystywane przez kartę programu i filtry katalogu.
   */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-na-madere-gory-nad-chmurami-mv143tfk.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-na-madere-gory-nad-chmurami-mv143tfk.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Madera'],
    continent: 'Europa',
    categories: [],
    travelStyles: ['Aktywnie'],
    catalogPublishedAt: '2026-10-10',
  },

  /* Terminy: 3 - 7 marca oraz 23 - 27 czerwca 2027. */
  tripIds: [28, 30],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '28': {
      pilotId: 'pawel',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Bezpośredni lot grupowy z Warszawy',
          description:
            'Wspólna podróż rozpoczyna się na Lotnisku Chopina w Warszawie. Lecimy bezpośrednio do Funchal i wracamy bezpośrednim rejsem do Warszawy.',
        },
        hotel: {
          title: 'Hotel 3★ w Funchal',
          description:
            'Cztery noclegi spędzamy w Funchal. Nocujemy w pokojach 2-osobowych, a każdy dzień rozpoczynamy od śniadania.',
        },
      },
    },

    '30': {
      pilotId: 'pawel',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Bezpośredni lot grupowy z Warszawy',
          description:
            'Wspólna podróż rozpoczyna się na Lotnisku Chopina w Warszawie. Lecimy bezpośrednio do Funchal i wracamy bezpośrednim rejsem do Warszawy.',
        },
        hotel: {
          title: 'Hotel 3★ w Funchal',
          description:
            'Cztery noclegi spędzamy w Funchal. Nocujemy w pokojach 2-osobowych, a każdy dzień rozpoczynamy od śniadania.',
        },
      },
    },
  },
}
